import { createContext, useContext } from "react";

interface MobileNavContextValue {
	openDrawer: () => void;
}

export const MobileNavContext = createContext<MobileNavContextValue>({
	openDrawer: () => {},
});

export function useMobileNav() {
	return useContext(MobileNavContext);
}
